import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import { CredentialsComponent } from './credentials/credentials.component';
import { CtaPanelComponent } from './cta-panel/cta-panel.component';
import { AppModalComponent } from './app-modal/app-modal.component';
import { DashboardComponent } from './dashboard/dashboard.component';

@NgModule({
  declarations: [PagetitleComponent, LoaderComponent, CredentialsComponent, CtaPanelComponent, AppModalComponent, DashboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule
  ],
  exports: [PagetitleComponent,LoaderComponent,CredentialsComponent,CtaPanelComponent, AppModalComponent, DashboardComponent]
})
export class UIModule { }
